import { Component, OnInit } from "@angular/core";

import { Router } from "@angular/router";

import { TokenService } from "../../services/token.service";

import { Helpers } from "../../helpers/helpers";

import jwt_decode from "jwt-decode";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { AccountService } from "src/services/account.service";
import { ComprehensiveBatchProcessService } from "../comprehensive-batch-process.service";

@Component({
  selector: "app-login",

  templateUrl: "./login.component.html",

  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  hide = true;
  isForgotPassword = false;
  constructor(
    private helpers: Helpers,
    private router: Router,
    private tokenService: TokenService,
    private snackBar: MatSnackBar,
    private accountService: AccountService,
    private comprehensiveBatchService: ComprehensiveBatchProcessService,
  ) {}

  email: string;
  password: string;
  error: any;
  isLoading = false;
  currentYear = new Date().getFullYear();
  ngOnInit() {
    if (this.helpers.isAuthenticated()) {
      this.checkLoggedIn();
    } else {
      this.helpers.logout();
    }
  }

  login(): void {
    this.isLoading = true;
    this.error = null;
    const authValues = { email: this.email, password: this.password };

    this.tokenService.auth(authValues).subscribe(
      (token) => {
        this.helpers.setToken(token);
        this.helpers.setEmail(this.email);
        const obj = this.getDecodedAccessToken(this.helpers.getToken());
        this.helpers.setId(
          obj[
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
          ],
        );
        this.checkLoggedIn();
      },
      (err) => {
        this.isLoading = false;
        const message =
          err?.error?.message ||
          err?.message ||
          "Invalid email or password. Please try again.";
        this.snackBar.open(message, "CLOSE", {
          horizontalPosition: "center",
          verticalPosition: "top",
          duration: 4000,
          panelClass: ["error-snackbar"],
        });
      },
      () => {
        this.isLoading = false;
      },
    );
  }

  checkLoggedIn() {
    const obj = this.getDecodedAccessToken(this.helpers.getToken());
    if (obj.type.indexOf("Administrator") === 0) {
      this.router.navigate(["/dashboard"]);
    } else if (obj.type.indexOf("OfficeAdministrator") === 0) {
      this.router.navigate(["/consumer-request"]);
    } else if (obj.type.indexOf("B2BPolicyAdministrator") === 0) {
      this.helpers.setName("Saiyarti Admin");
      this.router.navigate(["/policies"]);
    } else if (
      obj.type.indexOf("StoreCoordinator") === 0 ||
      obj.type.indexOf("StoreSalesPerson") === 0
    ) {
      this.router.navigate(["/store"]);
    } else if (
      obj.type.indexOf("LEVEL 0") === 0 ||
      obj.type.indexOf("LEVEL 1") === 0 ||
      obj.type.indexOf("LEVEL 2") === 0
    ) {
      this.accountService.getAccount().subscribe(
        (account) => {
          const agencyProducts = account.agencyProducts;
          if (agencyProducts && Array.isArray(agencyProducts)) {
            this.helpers.setProducts(agencyProducts);
            this.comprehensiveBatchService.init();

            const hasCareplus = agencyProducts.some(
              (p) => p.toLowerCase() === "careplus",
            );
            const isAgencyBulkPayment = account?.agency?.isAgencyBulkPayment;
            if (hasCareplus) {
              if (isAgencyBulkPayment) {
                this.router.navigate(["/careplus/careplus-dashboard"]);
              } else {
                this.router.navigate(["/careplus/careplus-agency-dashboard"]);
              }
            } else {
              this.router.navigate(["/agencies/agency-dashboard"]);
            }
          } else {
            this.router.navigate(["/agencies/agency-dashboard"]);
          }
        },
        (err) => {
          this.router.navigate(["/agencies/agency-dashboard"]);
        },
      );
    }
  }

  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch (Error) {
      return null;
    }
  }

  showForgotPassword() {
    this.isForgotPassword = true;
  }

  showLogin() {
    this.isForgotPassword = false;
  }

  resetPassword() {
    this.isLoading = true;
    this.error = null;
    this.tokenService.resetPassword(this.email).subscribe(
      () => {
        this.isLoading = false;
        this.snackBar.open(
          "Please check your email for the new password.",
          "CANCEL",
          {
            horizontalPosition: "right",
            duration: 4000,
          },
        );
      },
      (err) => {
        this.isLoading = false;
        const message =
          err?.error?.message ||
          err?.message ||
          "Failed to reset password. Please try again.";
        this.snackBar.open(message, "CLOSE", {
          horizontalPosition: "center",
          verticalPosition: "top",
          duration: 4000,
          panelClass: ["error-snackbar"],
        });
      },
    );
  }
}
